/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const MessageSquareQuote = [
  ["path", { d: "M14 14a2 2 0 0 0 2-2V8h-2" }],
  [
    "path",
    {
      d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z"
    }
  ],
  ["path", { d: "M8 14a2 2 0 0 0 2-2V8H8" }]
];

export { MessageSquareQuote as default };
//# sourceMappingURL=message-square-quote.js.map
